import { find, isEmpty, map } from 'lodash';
import { Fragment, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { StylizedNumber } from 'components';
import { TranslationNamespace } from 'i18n';
import { AgentInfo, User } from 'types';
import { userUtils } from 'utils';

type Props = {
  isPayin: boolean;
  agents?: AgentInfo[];
  users?: User[];
};

export const AgentsInfo: React.FC<Props> = ({ agents, users, isPayin }) => {
  const { t } = useTranslation(TranslationNamespace.Admin, {
    keyPrefix: 'pages.cashback.groups',
  });

  const getAgentName = useCallback(
    (agentId: string) => {
      const agentUser = find(users, (user) => user.id === agentId);
      return agentUser?.name || agentId;
    },
    [users],
  );

  if (isEmpty(agents)) {
    return null;
  }

  return (
    <Fragment>
      {map(agents, (agent: AgentInfo) => (
        <div className="tw-flex" key={agent.userId}>
          <span className="tw-pr-2">{getAgentName(agent.userId)}</span>
          <StylizedNumber
            value={userUtils.getAgentCommission(agent, isPayin)}
            unit="%"
          />
        </div>
      ))}
      <div className="tw-mt-2 tw-flex">
        <div className="tw-mr-2">{t('labels.total')}</div>
        <StylizedNumber
          value={userUtils.getAgentsCommission(agents!, isPayin)}
          unit="%"
        />
      </div>
    </Fragment>
  );
};
